import React from 'react'
import Footer from '../inc/Footer'
import { Link } from 'react-router-dom'

function About() {
  return (
    <div>
    <div className='container'>
        <div className="row text-center mt-3 justify-content-center align-items-center">
           

            <div className='col-md-10 '>
            <h2 style={{fontSize:"4rem"}}>Welcome to Indus Salvage</h2>
              <p>We are an Organization, serving online-auction amenities to our clients (Public & private motor-insurance companies) with an eminence and trustworthy consumer base. Been in the domain for half a decade, we have mastered the skill offline and now have arrived into the online space with an aim to showcase supreme and delightful facilities by leveraging technological and digital resources.</p>
            </div>
      </div>
    </div>
    <div className="container-fluid text-center justify-content-center align-items-center pb-5 m-0 p-0">
        <img src={window.location.origin + '/images/Client-Service.png'} className="img-fluid" />
      </div>
    <Footer/>
    </div>

  )
}

export default About